// JobContext.js
import { createContext, useState } from "react";

export const JobContext = createContext();

export const JobProvider = ({ children }) => {

    const [jobId, setJobId] = useState(null);
    const [progress, setProgress] = useState(0);
    const [jobData, setJobData] = useState(null);

    return (<JobContext.Provider value={{
        jobId,
        setJobId,
        progress,
        setProgress,
        jobData,
        setJobData
    }}>
        {children}
    </JobContext.Provider>);
};